import {createSvgIcon} from '../create-svg-icon';

export const ArrowRightIcon = createSvgIcon(
  <path d="M9.29 6.71a1 1 0 0 0 0 1.41L12.17 11H4a1 1 0 1 0 0 2h8.17l-2.88 2.88a1 1 0 1 0 1.42 1.41l4.59-4.59a1 1 0 0 0 0-1.41l-4.59-4.59a1 1 0 0 0-1.42 0z" />
, 'ArrowRight');